import React from 'react';
import styles from './styles/maincomponent.module.css';

const MainInfoComponent = ({
  heading,
  subheading,
  para,
  onReadMore,
  readMore,
  headingColor,
  subheadingColor,
  paraColor,
  readMoreColor,
}) => {
  const handleReadMore = () => {
    onReadMore();
    setTimeout(() => {
      const offset = -100;
      const topPosition = window.scrollY + offset;
      window.scrollTo({
        top: topPosition > 0 ? 0 : topPosition,
        behavior: "smooth",
      });
    }, 100);
  };

  return (
    <div className={styles.main_info_component}>
      <div>
        <div>
          <h1 style={headingColor ? { color: headingColor } : undefined}>
            {heading}
          </h1>
        </div>
        <div>
          <h4 style={subheadingColor ? { color: subheadingColor } : undefined}>
            {subheading}
          </h4>
        </div>
        <div>
          <div className={styles.main_para}>
            <p style={paraColor ? { color: paraColor } : undefined}>
              {para}
            </p>
          </div>
          <p
            className={styles.readmore}
            style={readMoreColor ? { color: readMoreColor } : undefined}
            onClick={handleReadMore}
          >
            {readMore}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainInfoComponent;